import { render } from "./PersonReinviteView.vue?vue&type=template&id=2cfa003e&scoped=true"
import script from "./PersonReinviteView.vue?vue&type=script&lang=js"
export * from "./PersonReinviteView.vue?vue&type=script&lang=js"

import "./PersonReinviteView.vue?vue&type=style&index=0&id=2cfa003e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfa003e"]])

export default __exports__